module.exports = __webpack_public_path__ + "static/flink-9bcd1c0da5d1299e8b5c8148aee0b98e.svg";